module.exports = __webpack_public_path__ + "img/camera.c8d4b115.svg";